import { ReportLoadingState } from "./parts/report-loading-state";

export function SurveyReportRouteFallback() {
  return (
    <ReportLoadingState className="min-h-80 items-center rounded-panel bg-surface shadow-raised" />
  );
}
